// extracted by mini-css-extract-plugin
export default {"container":"style_container__WAJiv","form-container":"style_form-container__jaG2l"};